import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  CircularProgress,
} from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";
import { Backdrop } from "@material-ui/core";

const WarningBox = ({ open, close, submit, message,deleteLoader,allow }) => {
  return (
    <Dialog open={open} onClose={close} fullWidth={true}>
      <DialogContent>
      {allow ?
        <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={deleteLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>:null
      }
     
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
        {message.includes("Check if invoice already entered under accounting") ? (
  null
) : (
  <HelpOutline color="secondary" fontSize="large" mt={2} />
)}
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
          p={2}
          mt={1}
        >
          <Typography variant="h4" style={{ width: "80%" }}>
            {message}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
          m={1}
        >
        <>
  {message.includes("Check if invoice already entered under accounting")? (
    <>
      <Button variant="contained" color="secondary" onClick={close}>
        OK
      </Button>
    </>
  ) : (
    <>
      <Button variant="outlined" color="secondary" onClick={close}>
        NO
      </Button>
      <Button
        variant="contained"
        color="secondary"
        onClick={submit}
        style={{ marginLeft: "20px" }}
      >
        Yes
      </Button>
    </>
  )}
</>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default WarningBox;
